import styled from 'styled-components'

const ChooseMoreItemRewardStyled = styled.div`
  width: 652px;
  position: relative;
  background-color: #4df285;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px;

  .choose-more-item-reward-modal {
    background-color: ${({ theme }) => theme.color.neutral};
    clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
    padding: 20px 30px;
    position: relative;
    min-height: 300px;
    min-width: 650px;
    .close-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: ${({ theme }) => theme.color.transparent};
      border: none;
      z-index: 1;
    }

    .line-condition {
      border-bottom: 2px solid ${({ theme }) => theme.color.lightGreen};
    }

    .height-85 {
      height: 90px;
    }

    .height-45 {
      height: 45px;
    }

    .title-choose-more-item-container {
      /* padding-bottom: 10px; */
      font-size: 30px;
      font-weight: 600;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
    }

    .choose-more-item-container {
      color: #DEDEDE;
      .items-list-container {
        position: relative;
        min-height: 525px;
        margin-top: 30px;
        .grid-container-title {
          display: grid;
          grid-template-columns: 1fr 2fr 3fr 1fr;
          gap: 16px;
          padding-bottom: 8px;
          border-bottom: 2px solid #4B4D54;
        }
        .item-title {
          text-align: center;
          font-size: 20px;
        }
        .grid-container {
          display: grid;
          grid-template-columns: 1fr 2fr 3fr 1fr;
          gap: 16px;
          margin-top: 8px;
          max-height: 420px;
          overflow: auto;
          scrollbar-gutter: stable;
          ::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }
          ::-webkit-scrollbar-track {
            border-radius: 10px;
            background: rgba(110, 109, 109, 0.1);
          }
          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background: rgba(110, 109, 109, 0.34);
          }
          ::-webkit-scrollbar-thumb:hover{
            background: rgba(110, 109, 109, 0.34);
          }
          ::-webkit-scrollbar-thumb:active{
            background: rgba(110, 109, 109, 0.34);
          }
        }
        .item {
          text-align: center;
          font-size: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .action {
          position: absolute;
          bottom: 0;
          right: 0;
          left: 0;
          margin-top: 30px;
          display: flex;
          justify-content: center;
        }
      }
      input[type='radio'] {
        transform: scale(1.3);
      }
      .prize-container {
        width: 100%;
        margin: 30px 30px 5px;
      }

      .ant-form {
        width: 100%;
      }

      .color-DEDEDE {
        color: #DEDEDE;
      }

      .box-prize {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        .title-label {
          display: flex;
          align-items: center;
          font-size: 18px;
          width: 30%;
        }

        .input-prize {
          flex: 1;
        }

        .ant-form-item {
          margin: 0;
        }
      }

      .btn-create {
        display: flex;
        justify-content: center;
        padding-top: 10px;
        width: 100%;
        gap: 20px;

        .ant-form-item {
          margin: 0;
        }
      }
    }

    .disabled_text {
      opacity: 0.3;
    }
  }
`

export default ChooseMoreItemRewardStyled
